/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../../services/search/solr_search_collection.ts"/>

module DealerwareWebComponents {
    "use strict";

    import DealerwareSolrSearchSmartFilter = DealerwareWebServices.DealerwareSolrSearchSmartFilter;

    export class ContractSearchDirectiveController {

        public static $inject : string[] = [
            '$dealerwareSolrSearchContractCollection',
            '$timeout',
            '$filter',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$state',
            '$q',
            '$rootScope',
            'CurrentUser',
            'DataUtils',
            '$controller',
            '$dealerwareInternationalizationDateFormats'
        ];

        public location: any;
        public selectedContract: any;
        public onContractSelected: any;
        public columns: any;
        public exportFilePrefix: string;
        public exportCols: any;
        public searchInProgress: boolean;
        public showClosedContracts: boolean;
        public dataUtils: any;
        public loader: any;

        public collectionListName: string = 'ContractCollectionList';
        public landingPageController: any;

        constructor(public $dealerwareSolrSearchContractCollection: any,
                    public $timeout: any,
                    public $filter: any,
                    public $mobilityCompanyAuthentication: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $state : any,
                    public $q : any,
                    public $rootScope: any,
                    public CurrentUser: any,
                    public DataUtils: any,
                    public $controller: any,
                    public $dealerwareInternationalizationDateFormats: any) {
            this.dataUtils = this.DataUtils.getInstance();
            this.initContractColumns();

            this.$rootScope.$on('$authCompanyChanged', (args: any) => {
                this.clear();
            });

            this.location = this.$mobilityCompanyAuthentication.location;
            this.exportFilePrefix = this.$filter('spaceless')(this.location.name.toLowerCase()) + '_contracts';
            $dealerwareSolrSearchContractCollection.locationId = this.location.id;

            // Load Contract search with 'all' vehicles.
            //
            this.$dealerwareSolrSearchContractCollection.searchArgs.searchText = 'all';
            this.searchContracts();
            this.$dealerwareSolrSearchContractCollection.searchArgs.searchText = '';

            this.landingPageController = this.$controller('LandingPageController');
        }

        public initContractColumns() : void {
            var _self = this;

            this.columns = [{
                key: 'id',
                hidden: true
            },{
                key: 'confirmation_token',
                header: 'Contract ID',
                sortable: true,
                onClick: function(e: any, contract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.contracts.details',
                        { contractId: contract.data.id }
                    ));
                }
            },{
                key: 'current_state',
                header: 'Status',
                sortable: true
            },{
                key: 'car.stock_number',
                header: 'Stock #',
                onClick: function(e: any, contract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.vehicles.details',
                        { vehicleId: contract.data.car.id }
                    ));
                }
            },{
                key: 'car.vin',
                header: 'VIN',
                onClick: function(e: any, contract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.vehicles.details',
                        { vehicleId: contract.data.car.id }
                    ));
                }
            },{
                key: 'actual_pickup',
                header: 'Contract Start',
                sortable: true,
                sortBy: 'actual_pickup',
                dataFilter: (ts: string) => {
                    var tz = this.location.time_zone_name;
                    var date = ts ? this.dataUtils.formatTimestampSimple(ts, tz) : null;
                    return date ? this.$filter('filterInternationalizationDate')(date) : undefined;
                }
            },{
                key: 'days_on_loan',
                header: 'Days on Contract',
                sortable: true,
                sortBy: '! actual_pickup'
            },{
                key: 'est_comp_date',
                header: 'Est. Completion',
                sortable: false,
                dataFilter: (d: Date) => {
                    return moment(d).isValid() ? this.$filter('filterInternationalizationDate')(d) : '';
                },
                hidden: () => {
                    return this.dataUtils.isBlank(this.location.settings.dms_provider);
                }
            },{
                key: 'ro_number',
                header: 'Repair Order',
                sortable: true
            },{
                key: 'service_vehicle_id',
                header: 'Service Vehicle ID',
                sortable: true
            },{
                key: 'service_advisor_name',
                header: 'Service Advisor',
                onClick: function(e: any, contract: any) {
                    if (_self.CurrentUser.user.hasRole('user_manager')) {
                        $(e.target).attr('href', _self.$state.href(
                            'root.private.application.employees.details',
                            { employeeId: contract.data.service_advisor_id }
                        ));
                    }
                }
            },{
                key: 'customer.full_name',
                header: 'Customer',
                onClick: function(e: any, contract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.customers.details',
                        { customerId: contract.data.customer_id }
                    ));
                }
            },{
                header: 'Profile',
                tooltip: 'Profile',
                iconFn: function(contract: any) { return contract.data.customer && contract.data.customer.has_complete_profile ? 'check' : 'close'; }
            }];

            this.exportCols = [
                {header: 'Contract ID',dataKey: 'confirmation_token'},
                {header: 'Status',dataKey: 'current_state'},
                {header: 'Stock #',dataKey: 'car.stock_number'},
                {header: 'VIN',dataKey: 'car.vin'},
                {
                    header: 'Contract Start',
                    dataFilter: (contract: any) => {
                        var tz = this.location.time_zone_name;
                        var date = contract.actual_pickup ? this.dataUtils.formatTimestampSimple(contract.actual_pickup, tz) : null;
                        return date ? this.$filter('filterInternationalizationDate')(date) : undefined;
                    }
                },
                {header: 'Days on Contract',dataKey: 'days_on_loan'},
                {header: 'Est. Completion',dataKey: 'est_comp_date',hidden: () => { return this.dataUtils.isBlank(this.location.settings.dms_provider); }},
                {header: 'Repair Order',dataKey: 'ro_number'},
                {header: 'Service Vehicle ID',dataKey: 'service_vehicle_id'},
                {header: 'Service Advisor',dataKey: 'service_advisor_name'},
                {header: 'Customer',dataKey: 'customer.full_name'},
                {header: 'Profile',dataKey: 'customer.has_complete_profile'}
            ];

        }

        public pageTransitionError(response: any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public contractSelected(record : any) : void {
            if (record instanceof DealerwareSolrSearchSmartFilter) {
                this.$dealerwareSolrSearchContractCollection.searchArgs.searchText = record.name;
                this.searchContracts();
            } else if (record) {
                this.selectedContract = record;
                if (this.onContractSelected && angular.isFunction(this.onContractSelected)) {
                    this.onContractSelected({record: record});
                }
            }
        }

        private _acq : any;

        public get autoCompletePromise() : any {
            return this._acq;
        }

        public set autoCompletePromise(acq : any) {
            this._acq = acq;
        }

        public cancelActiveAutoCompletePromise() {
            if (this._acq) {
                this._acq.resolve([]);
            }
            this._acq = undefined;
        }

        public newAutoCompletePromise() {
            this.cancelActiveAutoCompletePromise();
            this._acq = this.$q.defer();
            return this._acq;
        }

        public blurAutoComplete() {
            if ($('#contractSearchAutoComplete').find('input').length) {
                $('#contractSearchAutoComplete').find('input')[0].blur();
            }
        }

        public autoCompleteSearch() {
            var _self =this;
            var _deferred = this.newAutoCompletePromise();;

            if (this.searchInProgress) {
                this.$timeout(function() {
                    _self.cancelActiveAutoCompletePromise();
                },1);
            }
            else {
                this.$dealerwareSolrSearchContractCollection.searchArgs.locationId = this.location.id;
                this.$dealerwareSolrSearchContractCollection.searchArgs.live = true;
                if (!this.showClosedContracts) {
                    this.$dealerwareSolrSearchContractCollection.searchArgs.live_type = 'open';
                }
                else {
                    this.$dealerwareSolrSearchContractCollection.searchArgs.live_type = undefined;
                }

                this.$dealerwareSolrSearchContractCollection.autoCompleteSearch().then(
                    function(returnValue : any) {
                        _deferred.resolve(returnValue.data);
                        _self.autoCompletePromise = undefined;
                    },
                    function(response : any) {
                        console.log("search error!",response);
                        _deferred.reject([]);
                        _self.autoCompletePromise = undefined;
                    }
                );
            }

            return _deferred.promise;
        }

        public searchContracts(sortBy?: string,sortDirection?: string) : void {
            var _self = this;

            this.cancelActiveAutoCompletePromise();
            var sortArgs = this.updateSorting(sortBy, sortDirection);
            sortBy = sortArgs['sortBy'];
            sortDirection = sortArgs['sortDirection'];
            this.blurAutoComplete();

            if (!sortBy) {
                this.searchInProgress = true;
                sortBy = "pickup";
                sortDirection = "desc";
            } else {
                this.loader = this.$dealerwareLoading.show('Loading...');
            }

            this.$dealerwareSolrSearchContractCollection.searchArgs.sortBy = sortBy;
            this.$dealerwareSolrSearchContractCollection.searchArgs.sortDirection = sortDirection;
            this.$dealerwareSolrSearchContractCollection.searchArgs.locationId = this.location.id;

            this.$dealerwareSolrSearchContractCollection.searchArgs.live = true;
            if (!this.showClosedContracts) {
                this.$dealerwareSolrSearchContractCollection.searchArgs.live_type = 'open';
            }
            else {
                this.$dealerwareSolrSearchContractCollection.searchArgs.live_type = undefined;
            }

            this.$dealerwareSolrSearchContractCollection.search().then(
                function(returnValue : any) {
                    _self.$dealerwareSolrSearchContractCollection.searchResults.subject = 'contract';
                    if (_self.$dealerwareSolrSearchContractCollection.searchResults.recordTotal !== 1) {
                        _self.$dealerwareSolrSearchContractCollection.searchResults.subject += 's';
                    }
                    _self.searchInProgress = false;
                    if (_self.loader) { _self.loader.close(); }
                },
                function(response : any) {
                    _self.searchInProgress = false;
                    if (_self.loader) { _self.loader.close(); }
                    console.log("contract search error:",response);
                }
            );
        }

        public updateSorting(sortBy: string, sortDirection: string) : any {
            this.columns.forEach((c: any) => {
                if (c.key === sortBy || (c.sortBy !== undefined && c.sortBy === sortBy)) {
                    c.sortDirection = sortDirection;
                    var reverseSortRegExp = /^\! */;
                    if (reverseSortRegExp.test(sortBy)) {
                        sortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
                        sortBy = sortBy.replace(reverseSortRegExp, '');
                    }
                } else {
                    c.sortDirection = undefined;
                }
            });

            return { sortBy: sortBy, sortDirection: sortDirection };
        }

        public clear() : void {
            var collection = this.$dealerwareSolrSearchContractCollection;

            collection.searchArgs.clear();
            if (collection.searchResults) { collection.searchResults.clear(); }
        }

        public createContract() : void {
            this.$state.go('shortcuts.contractCreate');
        }
    }

    getDealerwareWebComponentsModule().controller('ContractSearchDirectiveController',ContractSearchDirectiveController);


    export class ContractSearchDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ContractSearchDirectiveController';
        public controllerAs     : string    =   'contractSearchController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {onContractSelected: '&'};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/contract/search/contract_search_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }

    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareContractSearch",() => new ContractSearchDirective());
}
